module.exports = __webpack_public_path__ + "img/preimush-img-5.2749a295.png";